import { FormInstance, Input as AntInput, Alert } from 'antd';
import { RobotOutlined } from '@ant-design/icons';
import { RefObject } from 'react';
import { Row, Column, Form, Select, Text, Divider, Checkbox } from '@bancobarigui/barihaus';

import { AddressFormItem, AddressFormRef } from '@/components/AddressForm';
import { ContactList } from '../ContactList';

interface ItemFormProps {
  form: FormInstance;
  addressFormRef?: RefObject<AddressFormRef>;
  inspectionTypes: {
    value: string;
    label: string;
    disabled: boolean;
    requiresInspector: boolean;
  }[];
  propertyTypes: {
    value: string;
    label: string;
    disabled: boolean;
  }[];
  reasons: {
    value: string;
    label: string;
    disabled: boolean;
  }[];
}

export function ItemForm({
  form,
  addressFormRef,
  inspectionTypes,
  propertyTypes,
  reasons,
}: ItemFormProps) {
  const addContactInfo = Form.useWatch('addContactInfo', form);
  const selectedInspectionTypeId = Form.useWatch('inspectionType', form);
  const selectedInspectionType = inspectionTypes.find((t) => t.value === selectedInspectionTypeId);
  const isAutomaticType = selectedInspectionType && !selectedInspectionType.requiresInspector;

  return (
    <>
      <div className="space-y-6">
        <div className="flex items-center">
          <Text className="text-lg font-semibold">Item</Text>
        </div>

        <Row gutter={[24, 16]}>
          <Column span={12}>
            <Form.Item
              name="inspectionReason"
              label="Motivo de Inspeção"
              rules={[{ required: true, message: 'Informe o motivo da inspeção.' }]}
            >
              <Select placeholder="Qual é o Motivo da Inspeção?" options={reasons} />
            </Form.Item>
          </Column>

          <Column span={12}>
            <Form.Item
              name="inspectionType"
              label="Tipo de Inspeção"
              rules={[{ required: true, message: 'Informe o tipo de inspeção.' }]}
            >
              <Select placeholder="Qual Tipo de Inspeção?" options={inspectionTypes} />
            </Form.Item>
          </Column>

          <Column span={12}>
            <Form.Item
              name="propertyType"
              label="Tipo de Imóvel"
              rules={[{ required: true, message: 'Informe o tipo de imóvel.' }]}
            >
              <Select placeholder="Qual Tipo de Imóvel?" options={propertyTypes} />
            </Form.Item>
          </Column>

          <Column span={8}>
            <Form.Item name="landArea" label="Área de Terreno (m²)">
              <AntInput type="number" placeholder="Ex: 250.00" step="0.01" min="0" />
            </Form.Item>
          </Column>

          <Column span={8}>
            <Form.Item name="builtArea" label="Área Construída (m²)">
              <AntInput type="number" placeholder="Ex: 150.00" step="0.01" min="0" />
            </Form.Item>
          </Column>

          <Column span={8}>
            <Form.Item name="privateArea" label="Área Privativa (m²)">
              <AntInput type="number" placeholder="Ex: 120.00" step="0.01" min="0" />
            </Form.Item>
          </Column>

          <Column span={8}>
            <Form.Item name="iptuNumber" label="N° IPTU">
              <AntInput placeholder="Ex: 123.456.789-0" maxLength={50} />
            </Form.Item>
          </Column>

          <Column span={8}>
            <Form.Item name="registrationNumber" label="N° Matrícula">
              <AntInput placeholder="Ex: 12345" maxLength={50} />
            </Form.Item>
          </Column>

          <Column span={8}>
            <Form.Item name="registryOfficeNumber" label="N° Cartório">
              <AntInput placeholder="Ex: 1° Cartório de Registro" maxLength={50} />
            </Form.Item>
          </Column>

          <Column span={24}>
            <Form.Item name="observation" label="Observação">
              <AntInput.TextArea rows={4} placeholder="Digite observações sobre o item" />
            </Form.Item>
          </Column>
        </Row>
      </div>

      <Divider>{null}</Divider>

      <div className="space-y-6">
        <div className="flex items-center">
          <Text className="text-lg font-semibold">Localização</Text>
        </div>

        <AddressFormItem ref={addressFormRef} form={form} />
      </div>

      <Divider>{null}</Divider>

      <div className="space-y-6">
        <div className="flex items-center">
          <Text className="text-lg font-semibold">Contatos</Text>
        </div>

        <Form.Item name="addContactInfo" valuePropName="checked" initialValue={false}>
          <Checkbox>Adicionar informações de contato</Checkbox>
        </Form.Item>

        {addContactInfo && <ContactList />}
      </div>

    </>
  );
}
